export default __webpack_public_path__ + "static/media/element_84.e4805ddc.webp";